<template>
  <div id="deeptextset">
    <div class="deviceAddBlock">
      <!-- <div class="control-tips">
        <p>{{$t("layertextset").tips_title}}</p>
        <div>
          {{$t("layertextset").tips_1}} <br />
          {{$t("layertextset").tips_2}}
        </div>
      </div> -->
      <div class="tableheader">
        <el-select @change="selectList()" v-model="testTypeSelected" :placeholder="$i18n.t('layertextset').please_select" size="small" style="margin-right:5px;width:100px">
          <el-option :label="$i18n.t('buchong').all" value=""></el-option>
          <el-option v-for="(item,index) in testType" :label="item" :value="index" :key="index"></el-option>
        </el-select>
        <el-select @change="selectList()" v-model="isEdit" :placeholder="$i18n.t('layertextset').please_select" size="small" style="margin-right:10px;width:100px">
          <el-option :label="$i18n.t('buchong').all" value=""></el-option>
          <el-option :label="$i18n.t('layertextset').had_edit" :value="1"></el-option>
          <el-option :label="$i18n.t('layertextset').no_edit" :value="0"></el-option>
        </el-select>
        <el-button class="btn1 btn_blue_boder" size="small" @click="goDel(-2)">{{$t("choose_reset")}}</el-button>
        <el-button @click="selectList()" class="btn3" type="primary" size="small">{{$t("search")}}</el-button>
        <el-input v-model="searchKeyword" class="codeshearch" size="small" :placeholder="$i18n.t('layertextset').keyword" ></el-input>
      </div>
      <div class="contenttable">
        <el-table :data="lists" style="width: 100%" ref="filterTable" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column width="170" prop="service_name" :label="$i18n.t('layertextset').test_type"></el-table-column>
          <el-table-column width="150" :label="$i18n.t('layertextset').test_result">
            <template slot-scope="scope">
              <div>
                {{changeValue(scope.row.value)}}
                <span v-if="!isPercentDz()">{{$i18n.t('layertextset').level_service}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="introduction" :label="$i18n.t('layertextset').test_introduction"></el-table-column>
          <el-table-column prop="advice" :label="$i18n.t('layertextset').test_advice"></el-table-column>
          <el-table-column width="220" :label="$i18n.t('contral')">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isedit == 1" @click="goDel(scope.row.id)" class="btn1 btn_blue_boder" type="primary" size="mini">{{$i18n.t('layertextset').reset_default}}</el-button>
              <el-button @click="goEdit(scope.row)" class="btn1" type="primary" size="mini">{{$t("edit")}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog width="45%" :title="$i18n.t('dx_edit_tips')" :visible.sync="dialogFormVisible">
            <el-form :model="form">
              <el-form-item :label="$i18n.t('layertextset').test_type" :label-width="formLabelWidth">
                <span>{{form.service_name}}</span>
              </el-form-item>
              <el-form-item :label="$i18n.t('layertextset').test_result" :label-width="formLabelWidth">
                <span>{{changeValue(form.value)}}</span>
                <span v-if="!isPercentDz()">{{$i18n.t('layertextset').level_service}}</span>
              </el-form-item>
              <el-form-item :label="$i18n.t('layertextset').test_introduction" :label-width="formLabelWidth">
                <el-input type="textarea" rows="4" v-model="form.introduction"></el-input>
              </el-form-item>
              <el-form-item :label="$i18n.t('layertextset').test_advice" :label-width="formLabelWidth">
                <el-input type="textarea" rows="4" v-model="form.advice"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">{{$t("normal_cancle")}}</el-button>
                <el-button type="primary" @click="submit">{{$t("normal_sure")}}</el-button>
            </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deeptextset',
  data () {
    return {
      doing: false,
      lists: null,
      allDataList: null,
      testType: null,
      testTypeSelected: "",
      isEdit: "",
      searchKeyword: "",
      dialogFormVisible: false,
      form: {},
      formLabelWidth: '0.8rem',
      ids: []
    }
  },
  created () {
	if(localStorage.locale !== 'zh'){
		this.formLabelWidth = '1.6rem'
	}
    this.getList()
  },
  methods: {
    selectList(){
      const allDataList = this.allDataList
      this.lists = new Array()
      for(let i in allDataList){
        if(this.testTypeSelected && this.testTypeSelected !== allDataList[i].service){
          continue
        }
        if(this.isEdit !== "" && this.isEdit != allDataList[i].isedit){
          continue
        }
        if(
          this.searchKeyword !== "" && 
          allDataList[i].service_name.indexOf(this.searchKeyword) == -1 && 
          (this.changeValue(allDataList[i].value)+this.$i18n.t('layertextset').level_service).indexOf(this.searchKeyword) == -1 && 
          allDataList[i].introduction.indexOf(this.searchKeyword) == -1 && 
          allDataList[i].advice.indexOf(this.searchKeyword) == -1
          ){
            continue
        }
        this.lists.push(allDataList[i])
      }
    },
    handleSelectionChange(val) {
      if (val) {
        this.ids = new Array()
        for(let i in val) {
          if(val[i].id && val[i].isedit == 1) {
            this.ids.push(val[i].id)
          }
        }
      }
      console.log(this.ids)
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    getList () {
      if (this.doing === true) {
        return false
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      let data = {'type': 'deep'}
      this.axios.post('/skinMgrSrv/settings/articleList', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.allDataList = response.data.list
          _this.lists = response.data.list
          _this.testType = response.data.test_type
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 500);
      })
    },
    goEdit (data) {
      this.form = data
      this.dialogFormVisible = true
    },
    goDel (res) {
      if (this.doing === true) {
        return false
      }
      let ids = new Array()
      if (res === -2) {
        ids = this.ids
      } else {
        ids.push(res)
      }
      if (ids.length === 0) {
        this.$message(this.$i18n.t('submitnotdefault'))
        return false
      }
      this.doing = true
      let _this = this
      let data = {'id': ids}
      this.axios.post('/skinMgrSrv/settings/articleReset', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.$message(_this.$i18n.t('resetdefaultsuccess'))
          _this.getList()
        } else {
          _this.$message(_this.$i18n.t('resetdefaultfail'))
        }
      })
    },
    submit () {
      if (this.doing === true) {
        return false
      }
      if (this.form.advice === '') {
        _this.$message(_this.$i18n.t('layertextset').message_advice_notnull)
        return false
      }
      if (this.form.introduction === '') {
        _this.$message(_this.$i18n.t('layertextset').message_introduction_notnull)
        return false
      }
      this.doing = true
      let _this = this
      let data = this.form
      this.axios.post('/skinMgrSrv/settings/articleEdit', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.$message(_this.$i18n.t('editsuccess'))
          _this.getList()
          _this.dialogFormVisible = false
        } else {
          _this.$message(_this.$i18n.t('editsfail'))
        }
        console.log(response.data)
      })
    }
  }
}
</script>
<style  lang="scss">
  #deeptextset {
    .tableheader{
      padding: 0.16rem;
    }
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
    .el-button--primary {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
    }
    .btn_blue_boder{
      border: #57AEC9 1px solid;
      color: #57AEC9;
      background-color: #fff;
    }
    .el-scrollbar__wrap {
      height: auto;
    }
  }
  .el-table-filter__content {
    min-width: 1.2rem;
  }
  .el-table-filter__wrap {
    max-height: 323px;
  }
  .el-table-filter__bottom {
    height: 0.2rem;
    display: block;
    position: relative;
  }
  .el-table-filter__bottom button{
    position: absolute;
    top: 0.06rem;
    left: 0.2rem;
  }
  .el-table-filter__bottom button:last-child{
    left: 0.7rem;
  }
  .el-scrollbar .el-scrollbar__wrap {
    margin-bottom: -17px !important;
  }
  
</style>

<style scoped lang="scss">
  #deeptextset {
    padding: 0 0.166rem;
    box-sizing: border-box;
    p.title{
      height: 0.4167rem;
      line-height:0.4167rem;
      font-size:0.15rem;
      color:#000;
    }
    .btn2,.btn3{
      padding: 0.0667rem 0.0833rem;
    }
    .codeshearch{
      width: 1.667rem;
    }
    .btn3,.codeshearch{
      float: right;
    }
    .deviceAddBlock{
      margin-top: 0.16rem;
      background-color: #fff;
      border-radius: 0.04166rem;
      padding: 0.0833rem;
      div.control-tips{
        border-radius: 0.04166rem;
        height: 0.4833rem;
        color: #57AEC9;
        font-size: 14px;
        padding: 0.1667rem;
        width: calc(100% - 0.64rem);
        background-color: #fff;
        border: 1px solid #FFCEE5;
        margin: 0.1667rem;
      }
      div.control-tips p{
        font-size: 0.116rem;
      }
      div.control-tips div{
        font-size: 0.116rem;
        margin:0.0833rem 0;
        line-height: 160%;
      }
      .contenttable{
        margin: 0.1667rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/config/deeptextset.vue